import { Typography } from '@mui/material';
import React from 'react';
import Row from 'src/frontend-common/components/Row';
import { SubmitGrid, ButtonWrapper, CustomWidthTooltip, RadioButtonComponent } from 'src/style/common';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { EnrichmentTime } from 'src/pages/ManualLookup/GenericForm/utils';
import ButtonComponent from 'src/components/ButtonComponent';

const enrichmentTooltip = (
  <>
    <span>
      <strong>MINIMAL:</strong> enrichment time set to 1.7 seconds, for time-sensitive use cases.
    </span>
    <span>
      <strong>NORMAL:</strong> enrichment time set to 3 seconds.
    </span>
    <span>
      <strong>EXTENSIVE (recommended):</strong> will ensure maximum signal coverage
    </span>
    <span>
      Learn more about API latency and enrichment time{' '}
      <a href="https://docs.trustfull.com/docs/response-times" target="_blank" rel="noreferrer">
        HERE
      </a>
      .
    </span>
  </>
);

const SubmitGridComponent: React.FC<{
  enrichmentTime: EnrichmentTime;
  setEnrichmentTime: React.Dispatch<React.SetStateAction<EnrichmentTime>>;
  isDisabled: boolean;
  onClickFn: () => void;
}> = ({ enrichmentTime, setEnrichmentTime, isDisabled, onClickFn }) => {
  return (
    <SubmitGrid xs={12} md={6} item>
      <ButtonWrapper>
        <CustomWidthTooltip title={enrichmentTooltip}>
          <Typography variant="body2" color="text.secondary">
            Enrichment time <InfoOutlinedIcon />
          </Typography>
        </CustomWidthTooltip>

        <Row>
          <RadioButtonComponent
            isactive={enrichmentTime === 'minimal' ? 'true' : 'false'}
            text="MINIMAL"
            buttontype="cancel"
            onClick={() => setEnrichmentTime('minimal')}
          />
          <RadioButtonComponent
            isactive={enrichmentTime === 'normal' ? 'true' : 'false'}
            text="NORMAL"
            buttontype="cancel"
            onClick={() => setEnrichmentTime('normal')}
          />
          <RadioButtonComponent
            isactive={enrichmentTime === 'extensive' ? 'true' : 'false'}
            text="EXTENSIVE"
            buttontype="cancel"
            onClick={() => setEnrichmentTime('extensive')}
          />
        </Row>
      </ButtonWrapper>
      <ButtonComponent
        buttontype="mainaction"
        type="submit"
        text="Submit"
        data-testid="form-submit-button"
        sx={{ height: 36 }}
        disabled={isDisabled}
        onClick={onClickFn}
      />
    </SubmitGrid>
  );
};

export default SubmitGridComponent;
